import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_UNSUBSCRIBE,
  UNSUBSCRIBE_ROUTE_NAME,
} from './constants';
import { getTranslationKeys } from './translations';

export class UnsubscribeModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addSharedRoute({
      name: UNSUBSCRIBE_ROUTE_NAME,
      path: '/unsubscribe/:token',
      component: () => import('@modules/unsubscribe/pages/UnsubscribePage/UnsubscribePage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_UNSUBSCRIBE, getTranslationKeys);
  }
}
